import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';

interface Props {
  width: number;
  color?: string;
}

const EventProgressBarInnerBar = styled.div.attrs((props: Props) => {
  const { width } = props;
  return {
    style: {
      width: `${width}%`,
    },
  };
})<Props>`
  background: ${(props) => props.color || Colors.progress.fill};
  border-radius: ${10 * Screen.widthRatio}px;
  height: ${12 * Screen.widthRatio}px;
`;

export default EventProgressBarInnerBar;
